import { IconRefresh, IconCaretLeft, IconSearch, IconPlus, IconDownload  } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, Button, Table, Form, Container, Row, Col, Alert, Pagination, InputGroup, Dropdown, ButtonGroup, DropdownButton } from "react-bootstrap";
import StatusFilterBar from "../components/StatusFilterBar";
import { Helmet } from "react-helmet-async";



const ProjectView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [project, setProject] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedUrls, setSelectedUrls] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
  const [summary, setSummary] = useState({});
  const [activeFilter, setActiveFilter] = useState(null);
const [selectedIds, setSelectedIds] = useState([]);
const [user, setUser] = useState({});
const [showAddLinksModal, setShowAddLinksModal] = useState(false);
const [showEditModal, setShowEditModal] = useState(false);
  
useEffect(() => {
  const fetchUser = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch("/api/auth/profile", {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await response.json();
      setIsAdmin(data.role === "admin");
    } catch (error) {
      // silently ignore
    }
  };
  fetchUser();
}, []);

    const [urlsPerPage, setUrlsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [urls, setUrls] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [sortBy, setSortBy] = useState("creation_date");
    const [sortOrder, setSortOrder] = useState("desc");
    const [refreshDisabled, setRefreshDisabled] = useState({});

    useEffect(() => {
        fetchProject();
    }, [id]);

useEffect(() => {
  fetchUrls();
}, [currentPage, urlsPerPage, sortBy, sortOrder, activeFilter]);

useEffect(() => {
  const interval = setInterval(async () => {
    // Check only URLs with Indexable? = Pending...
    const pendingIds = urls
      .filter(u => u.indexing_status?.toLowerCase().includes("pending"))
      .map(u => u.id);

    if (pendingIds.length === 0) return;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch("/api/urls/status", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(pendingIds)
      });

      if (response.ok) {
        const updatedData = await response.json();

        // Update only statuses in the existing list
        setUrls(prevUrls =>
          prevUrls.map(url => {
            const found = updatedData.find(u => u.id === url.id);
            if (found) {
              return {
                ...url,
                indexing_status: found.indexing_status,
                index_google_status: found.index_google_status,
                snippet_info: found.snippet_info
              };
            }
            return url;
          })
        );
      }
    } catch (err) {
      // silently ignore
    }
  }, 5000);

  return () => clearInterval(interval);
}, [urls]);


useEffect(() => {
  setCurrentPage(1);
}, [searchQuery, activeFilter]);

    const fetchProject = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            const projectResponse = await fetch(`/api/projects/${id}`, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (!projectResponse.ok) {
                if (projectResponse.status === 403 || projectResponse.status === 404) {
                    navigate("/404");
                    return;
                }
                throw new Error("Failed to load project");
            }
            const projectData = await projectResponse.json();
            setProject(projectData);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    
const userRole = user?.role || "";

const handleRecheck = async (urlId) => {
  if (refreshDisabled[urlId]) return;
  try {
    setRefreshDisabled(prev => ({ ...prev, [urlId]: true }));
    const token = localStorage.getItem("token");
    const response = await fetch(`/api/projects/${id}/urls/${urlId}/recheck`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`
      }
    });
    if (!response.ok) throw new Error("Recheck failed");

    // Locally mark as pending
    setUrls(prev =>
      prev.map((url) =>
        url.id === urlId ? { ...url, indexing_status: "pending" } : url
      )
    );

    // 🔄 Refresh this row every 5 seconds (up to 6 times) until status changes from pending
    let attempts = 0;
    const intervalId = setInterval(async () => {
      attempts++;
      const token = localStorage.getItem("token");
      const url = `/api/projects/${id}/urls?limit=${urlsPerPage}&page=${currentPage}&sort_by=${sortBy}&sort_order=${sortOrder}`;
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) return;
      const data = await res.json();
      const updated = data.urls.find((u) => u.id === urlId);
      if (updated && updated.indexing_status !== "pending") {
        setUrls((prev) =>
          prev.map((url) => (url.id === urlId ? updated : url))
        );
        clearInterval(intervalId);
      }
      if (attempts >= 6) clearInterval(intervalId); // stop after ~30 seconds
    }, 5000);

    // Re-enable button after 15 seconds
    setTimeout(() => {
      setRefreshDisabled(prev => {
        const copy = { ...prev };
        delete copy[urlId];
        return copy;
      });
    }, 15000);
  } catch (e) {
    // silently ignore
  }
};


    const fetchUrls = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            let url = `/api/projects/${id}/urls?limit=${urlsPerPage}&page=${currentPage}&sort_by=${sortBy}&sort_order=${sortOrder}`;
if (activeFilter) {
  url += `&status=${encodeURIComponent(activeFilter)}`;
}
const urlsResponse = await fetch(url, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (!urlsResponse.ok) throw new Error("Failed to load links");
            const urlsData = await urlsResponse.json();
            setUrls(urlsData.urls || []);
            setTotalCount(urlsData.total_count || 0);
const pages = Math.ceil((urlsData.total_count || 0) / urlsPerPage);
setTotalPages(pages);
if (pages > 0 && currentPage > pages) {
  setCurrentPage(pages);
}
if (pages === 0 && currentPage !== 1) {
  setCurrentPage(1);
}
            setSummary(urlsData.summary || {});
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteSelected = async () => {
        if (selectedUrls.length === 0) return;

        const confirmDelete = window.confirm("Are you sure you want to delete the selected links?");
        if (!confirmDelete) return;

        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`/api/projects/${id}/delete-links`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ link_ids: selectedUrls })
            });

            if (!response.ok) throw new Error("Failed to delete links");

            setSelectedUrls([]);
            fetchUrls();
        } catch (error) {
            // silently ignore
        }
    };
    
    
    const getPaginationPages = (current, total) => {
  if (total < 1) return [];
  const delta = 2;
  const pages = new Set([1, total]);
  for (let i = current - delta; i <= current + delta; i++) {
    if (i > 1 && i < total) pages.add(i);
  }
  const sorted = Array.from(pages).sort((a, b) => a - b);
  const result = [];
  for (let i = 0; i < sorted.length; i++) {
    result.push(sorted[i]);
    if (i < sorted.length - 1 && sorted[i + 1] - sorted[i] > 1) result.push("...");
  }
  return result;
};

// derived pagination values
const pagesToShow = getPaginationPages(currentPage, totalPages);
const showPagination = totalCount > 0 && pagesToShow.length > 0;
const startIdx = totalCount === 0 ? 0 : (currentPage - 1) * urlsPerPage + 1;
const endIdx = totalCount === 0 ? 0 : Math.min(currentPage * urlsPerPage, totalCount);
    
    const exportUrls = async (type) => {
  const token = localStorage.getItem("token");
  const res = await fetch(`/api/projects/${id}/export?type=${type}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `project-${id}-${type}.${type === "csv" ? "csv" : "txt"}`;
  a.click();
};

const extractRedirectUrl = (text) => {
  const match = text?.match(/Redirected to (https?:\/\/[^\s–]+)/);
  return match ? match[1].trim() : null;
};



// === Snippet helpers ===
const containsNonRenderableTag = (html) => {
  if (!html) return false;
  return /<\s*(meta|link|script|style)\b/i.test(html);
};

const escapeHTML = (s) => {
  if (s == null) return "";
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
};

const renderSnippetInfo = (url) => {
  if (url.index_google_status === "Indexed" && url.snippet_title) {
    return (
      <div>
        <div style={{ color: "#1a0dab", fontWeight: 500 }}>{url.snippet_title}</div>
        <div style={{ color: "#000" }}>{url.snippet_description}</div>
      </div>
    );
  }

  if (
    url.index_google_status === "Non indexable (refunded)" &&
    url.snippet_info === "Indexing not possible, please try again later"
  ) {
    return <div style={{ color: "#555" }}>Indexing not possible, please try again later</div>;
  }

  if (url.snippet_info && (
        url.indexing_status?.startsWith("NO (301") ||
        url.indexing_status?.startsWith("NO (302") ||
        url.indexing_status?.startsWith("NO (303") ||
        url.indexing_status?.startsWith("NO (304") ||
        url.indexing_status?.startsWith("NO (307")
      )) {
    return (
      <span>
        ❌Redirected to {extractRedirectUrl(url.snippet_info) || "URL"} – remove the redirect
      </span>
    );
  }

  if (url.snippet_info) {
    if (containsNonRenderableTag(url.snippet_info)) {
      return (
        <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0 }}>
          {url.snippet_info}
        </div>
      );
    }
    return <div dangerouslySetInnerHTML={{ __html: url.snippet_info }} />;
  }

  return "Waiting for check";
};
// === End snippet helpers ===

const renderSortHeader = (label, field) => (
  <span
    style={{ cursor: "pointer" }}
    onClick={() => {
      if (sortBy === field) {
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
      } else {
        setSortBy(field);
        setSortOrder("asc");
      }
    }}
  >
    {label} {sortBy === field && (sortOrder === "asc" ? "▲" : "▼")}
  </span>
);

    return (
        <>
            <Helmet>
      <title>{project?.name ? `${project.name} - IndexBooster` : "IndexBooster"}</title>
    </Helmet>
                {loading && (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-2 text-muted">Loading...</div>
      </div>
    )}
    
    {error && <Alert variant="danger">{error}</Alert>}
    {!loading && 


            project && (<Card>
                
<Card.Header className="d-flex flex-wrap justify-content-between align-items-start gap-2">
  <div className="d-flex align-items-center gap-2 flex-grow-1">
    <Button variant="light" size="sm" onClick={() => navigate("/")}>
       <IconCaretLeft size={18} />
    </Button>
    <h3 className="card-title text-break m-0" style={{ wordBreak: "break-word", minWidth: 0, maxWidth: "100%" }}>
      {project.name}{" "}
  <Link to={`/project/${id}/edit`} className="ms-2 text-muted small">Edit</Link>
    </h3>
  </div>
  <div className="d-flex gap-2">
    <Button onClick={() => navigate(`/project/${id}/add-links`)} variant="primary" className="d-flex align-items-center gap-2 px-4 py-2" style={{ fontSize: "14px" }}>
      <IconPlus size={18} />
      Add Links
    </Button>
    <Dropdown as={ButtonGroup}>
      <Dropdown.Toggle className="btn btn-success d-flex align-items-center gap-2 px-4 py-2" style={{ fontSize: "14px" }}>
        <IconDownload size={18} />
        Export URLs
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => exportUrls("csv")} className="d-flex align-items-center gap-2">
          <IconDownload size={16} />
          CSV all columns links
        </Dropdown.Item>
        <Dropdown.Item onClick={() => exportUrls("txt_all")} className="d-flex align-items-center gap-2">
          <IconDownload size={16} />
          TXT all links
        </Dropdown.Item>
        <Dropdown.Item onClick={() => exportUrls("txt_indexed")} className="d-flex align-items-center gap-2">
          <IconDownload size={16} />
          TXT all indexed links
        </Dropdown.Item>
        <Dropdown.Item onClick={() => exportUrls("txt_non_indexed")} className="d-flex align-items-center gap-2">
          <IconDownload size={16} />
          TXT all non indexed links (refunded)
        </Dropdown.Item>
        <Dropdown.Item onClick={() => exportUrls("txt_non_indexables")} className="d-flex align-items-center gap-2">
          <IconDownload size={16} />
          TXT all non indexables links (refunded)
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  </div>
</Card.Header>

                {project.description && (
                    <Card.Body className="card-body">
                        <p>{project.description}</p>
                    </Card.Body>
                )}
                
<Card.Body className="border-bottom py-3">
  <StatusFilterBar summary={summary} activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
  <div className="d-flex justify-content-start">
    <InputGroup style={{ maxWidth: 300 }}>
      <InputGroup.Text>
        <IconSearch size={18} />
      </InputGroup.Text>
      <Form.Control
        placeholder="Search by URL"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </InputGroup>
  </div>
</Card.Body>

                <div className="table-responsive">
                    <Table className="table card-table table-vcenter text-nowrap datatable">
                        <thead>
                            <tr>
{isAdmin && (
  <th className="w-1">
    <Form.Check type="checkbox" onChange={(e) => setSelectedUrls(e.target.checked ? urls.map(u => u.id) : [])} />
  </th>
)}
                                  <th className="text-start">{renderSortHeader("URL", "url")}</th>
                               <th className="text-center">{renderSortHeader("Indexable?", "indexing_status")}</th>
                               <th className="text-center">{renderSortHeader("Creation Date", "creation_date")}</th>
                               <th className="text-center">{renderSortHeader("Status", "index_google_status")}</th>
                               <th className="text-center">{renderSortHeader("Snippet Info", "snippet_info")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {urls.filter(url => url.url.toLowerCase().includes(searchQuery.toLowerCase())).length === 0 ? (
                                <tr><td colSpan="6" className="text-center py-4">Links not found</td></tr>
                            ) : (
                                urls.filter(url => url.url.toLowerCase().includes(searchQuery.toLowerCase())).map((url) => (
                                    <tr key={url.id}>
                                        {isAdmin && (<td>
                                            <Form.Check type="checkbox" checked={selectedUrls.includes(url.id)}
                                                onChange={(e) => {
                                                    setSelectedUrls((prev) =>
                                                        e.target.checked ? [...prev, url.id] : prev.filter((id) => id !== url.id)
                                                    );
                                                }}
                                            />
                                        </td>)}
                                        <td style={{ whiteSpace: "normal", wordBreak: "break-word", minWidth: "300px", maxWidth: "100%", flexGrow: 1 }}>
                                            <a href={url.url} target="_blank" rel="noopener noreferrer" className="text-dark text-decoration-none">
                                                {url.url}
                                            </a>
                                        </td>
                                        
<td className="text-center">
  {url.indexing_status === "pending" ? (
    <span className="text-warning">Pending...</span>
  ) : url.indexing_status?.startsWith("YES") ? (
    <span className="text-success">{url.indexing_status}</span>
  ) : (
    <span className="text-danger d-inline-flex align-items-center gap-1">
      <Button
        variant="link"
        size="sm"
        className="p-0 m-0 text-danger"
        onClick={() => handleRecheck(url.id)}
        disabled={refreshDisabled[url.id]}
        title="Recheck"
      >
        <IconRefresh size={14} />
      </Button>
      {url.indexing_status}
    </span>
  )}
</td>

                                        <td className="text-center">{new Date(url.creation_date).toLocaleString()}</td>
<td className="text-center" style={{ minWidth: "220px" }}>
{url.index_google_status === "Request in progress" ? (
  <div className="alert alert-info py-1 px-2 mb-0 w-100">
    Request in progress
  </div>
) : url.index_google_status === "Non indexable (refunded)" ? (
  <div className="alert alert-danger py-1 px-2 mb-0 w-100">
    Non indexable (refunded)
  </div>
) : url.index_google_status === "Non indexed (refunded)" ? (
  <div className="alert alert-danger py-1 px-2 mb-0 w-100">
    Non indexed (refunded)
  </div>
) : url.index_google_status === "Indexed" ? (
  <div className="alert alert-success py-1 px-2 mb-0 w-100">
    Indexed
  </div>
) : (
  <span className="text-muted">—</span>
)}

</td>


<td style={{ maxWidth: "400px", whiteSpace: "normal", wordBreak: "break-word", textAlign: "left" }}>
  {renderSnippetInfo(url)}
</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
<Card.Footer className="px-4">
  <div className="d-flex flex-column gap-2 w-100">

    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 w-100">
      <div className="d-flex align-items-center flex-wrap gap-3">
        {showPagination && (
          <Pagination className="m-0 flex-wrap">
            <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>«</Pagination.Prev>
            {pagesToShow.map((p, i) =>
              p === "..." ? (
                <Pagination.Ellipsis key={`ellipsis-${i}`} disabled />
              ) : (
                <Pagination.Item
                  key={`page-${p}`}
                  active={p === currentPage}
                  onClick={() => setCurrentPage(p)}
                >
                  {p}
                </Pagination.Item>
              )
            )}
            <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>»</Pagination.Next>
          </Pagination>
        )}

        <div className="text-muted">
          Showing <b>{startIdx}</b>–<b>{endIdx}</b> of <b>{totalCount}</b> entries
        </div>
      </div>

      <div className="d-flex align-items-center gap-2 ms-md-auto">
        <span className="text-muted">Show</span>
        <Form.Select
          value={urlsPerPage}
          onChange={(e) => {
            setCurrentPage(1);
            setUrlsPerPage(Number(e.target.value));
          }}
          size="sm"
        >
          {[10, 50, 100, 500, 1000].map((val) => (
            <option key={val} value={val}>{val}</option>
          ))}
        </Form.Select>
        <span className="text-muted">entries</span>
      </div>
    </div>

    {isAdmin && (
      <div className="d-flex justify-content-start">
        <Button
          variant="danger"
          disabled={selectedUrls.length === 0}
          onClick={handleDeleteSelected}
        >
          Delete Selected
        </Button>
      </div>
    )}
  </div>
</Card.Footer>

            </Card>)}
        </>
    );
};

export default ProjectView;
